import { useNavigate } from "react-router-dom";

import CommonPopup from "..";
import CommonButton from "../../Button";

type Props = {
  popup: string;
  onClose: () => void;
};

export default function ReservationLimitPopup({ popup, onClose }: Props) {
  const navigate = useNavigate();

  return (
    <CommonPopup
      isOpen={popup === "reservationLimit"}
      onClose={onClose}
      padding={0}
    >
      <div className="p-5 whitespace-pre-line text-xl font-medium text-center">
        {
          "공간예약 최대 이용횟수를 초과 하였습니다.\n히스토리에서 기존 예약내용을\n참고 부탁드립니다."
        }
      </div>
      <CommonButton
        className="w-full h-bottom-button rounded-none"
        onClick={() => {
          navigate("/history", { state: { isReservationLimit: true } });
        }}
      >
        확인
      </CommonButton>
    </CommonPopup>
  );
}
